<div class="cumulio-container" *ngIf="authKey && authToken">
  <cumulio-dashboard #dashboardInstance
    editMode="view"
    [authKey]="authKey"
    [authToken]="authToken"
    [dashboardId]="'99278195-7af4-402d-b852-37be75011935'"
    [loaderBackground]="'rgb(238,243,246)'">
  </cumulio-dashboard>
</div>
